import { getPolicyViolatedWords } from './monetization/get-policy-violated-words';
import { hasDiageoViolatedWords } from './monetization/has-diageo-violated-words.js';
import { getNestedText } from '../services/article/get-nested-text.js';

export const GROUP_DISABLED = `a`;
export const GROUP_ENABLED = `b`;
export const aditudeGroup = window.Site.abTests.aditude;
export const isAditudeEnabled = aditudeGroup === GROUP_ENABLED;

export const setAditudeTargeting = (targeting, isInfinite = false) => {
  window.htlbid = window.htlbid || {};
  htlbid.cmd = htlbid.cmd || [];

  htlbid.cmd.push(() => {
    Object.entries(targeting).forEach(([key, value]) => {
      htlbid.setTargeting(key, value);
    });

    isInfinite ? htlbid.newPage() : htlbid.layout();
  });
};

export const initAditudeScript = () => {
  if (isAditudeEnabled) {
    const targeting = window.Site.targeting || {};
    const $fullArticleContent = document.querySelector(`.js-article`);

    window.tude = window.tude || {};
    window.tude.cmd = window.tude.cmd || [];

    window.tude.cmd.push(() => {
      window.gtag?.(`event`, `aditude_script_load`);
    });

    if ($fullArticleContent) {
      const contentText = getNestedText($fullArticleContent);

      targeting.violated_words = getPolicyViolatedWords(contentText);
      targeting.has_diageo_words = hasDiageoViolatedWords(contentText);
    }

    targeting.is_testing = `no`;

    setAditudeTargeting(targeting);
  }
};
